import { render, staticRenderFns } from "./ReadPromise.vue?vue&type=template&id=ec32046a&"
import script from "./ReadPromise.vue?vue&type=script&lang=js&"
export * from "./ReadPromise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports